var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-info"},[_c('Head',{attrs:{"webInfoObj":_vm.webInfoObj}}),_c('router-view'),_c('Footer',{attrs:{"webInfoObj":_vm.webInfoObj}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }